import React, { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";

import CountUp from "react-countup";
import scrolldown from "../../../../assets/icons/scrolldown.svg";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import OtherProductsCard from "./projectCard/OtherProductsCard";
import { useInView } from "react-intersection-observer";
import gsap from "gsap";
import { SplitText } from "gsap/SplitText";
import {
    Fade,
    Hinge,
    JackInTheBox,
    Roll,
    Slide,
    Zoom,
} from "react-awesome-reveal";
import { Link } from "react-router-dom";

function SingleProject({ data, setIsLoading, isLargeScreen }) {
    const sceneRef = useRef(null);
    const location = useLocation();
    const [statRef, statInView] = useInView({ triggerOnce: true });
    const [productDetails, setProductDetails] = useState([]);
    const imgRef = useRef(null);
    const { linkRoute } = useParams();
    useEffect(() => {
        setIsLoading(false);
    }, []);
    useEffect(() => {
        const product = data?.art?.find((x) => x.linkRoute === linkRoute);
        setProductDetails(product);
    }, [linkRoute, productDetails, data]);
    const isLightcyclePage = location.pathname === "/products/lightcycle";
    useEffect(() => {
        const handleScroll = () => {
            if (sceneRef.current && imgRef.current) {
                const scrollY = window.scrollY;
                const translateY = scrollY * -0.7; // Adjust the speed of the parallax effect

                gsap.to(imgRef.current, {
                    y: translateY,
                    duration: 0.5, // Duration of the animation
                    ease: "power2.out", // Easing function
                });
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() => {
        gsap.registerPlugin(SplitText);
        const innovationpara = new SplitText("#innovationpara", {
            type: "words",
        });

        gsap.from(innovationpara.words, {
            duration: 3,
            opacity: 0,

            ease: "power1.inOut",
            stagger: {
                each: 0.13,
                from: "start",
            },
        });

        return () => {
            innovationpara.revert();
        };
    }, []);

    const scrollToElement = (id) => {
        const element = document.getElementById(id);

        if (element) {
            gsap.to(window, {
                scrollTo: {
                    y: element.offsetTop,
                    offsetY: 100, // adjust this value as needed
                },
                ease: "power2.inOut",
            });
        }
    };

    // console.log("product", data);
    const parseStat = (stat) => {
        const match = stat.match(/(\d+)(.*)/);
        return {
            value: match ? parseInt(match[1], 10) : 0,
            suffix: match ? match[2] : "",
        };
    };

    return (
        <div
            id="scene"
            className="relative  overflow-hidden text-center flex   flex-col  z-10 px-10 p-4 "
        >
            {" "}
            {productDetails?.singleProduct?.map((item) => (
                <div className="z-20 text-white  relative md:w-[90%]   w-full  mx-auto  text-left ">
                    {isLargeScreen ? (
                        <div className=" ">
                            {" "}
                            <div class="absolute top-[-220px] inset-y-0 left-0 w-px bg-white/10 z-0"></div>
                            <div class="absolute  top-[-220px] inset-y-0 left-1/3 w-px bg-white/10 z-0"></div>
                            <div class="absolute  top-[-220px] inset-y-0 left-2/3 w-px bg-white/10 z-0"></div>
                            <div class="absolute  top-[-220px] inset-y-0 right-0 w-px bg-white/10 z-0"></div>
                            <div class="absolute inset-y-0 left-0 w-px bg-white/10 z-0"></div>
                            <div class="absolute inset-y-0 left-1/3 w-px bg-white/10 z-0"></div>
                            <div class="absolute inset-y-0 left-2/3 w-px bg-white/10 z-0"></div>
                            <div class="absolute inset-y-0 right-0 w-px bg-white/10 z-0"></div>
                        </div>
                    ) : (
                        <div>
                            {" "}
                            <div class="absolute top-[-220px] inset-y-0 left-0 w-px bg-white/10 z-0"></div>
                            <div class="absolute  top-[-220px] inset-y-0 left-1/2 w-px bg-white/10 z-0"></div>
                            <div class="absolute  top-[-220px] inset-y-0 right-0 w-px bg-white/10 z-0"></div>
                            <div class="absolute inset-y-0 left-0 w-px bg-white/10 z-0"></div>
                            <div class="absolute inset-y-0 left-1/2 w-px bg-white/10 z-0"></div>
                            <div class="absolute inset-y-0 right-0 w-px bg-white/10 z-0"></div>
                        </div>
                    )}

                    <div className="lg:min-h-screen relative   h-screen align-middle flex flex-col justify-center ">
                        {" "}
                        <img
                            onClick={() => scrollToElement("secondpage")}
                            src={scrolldown}
                            className="absolute top-[90%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 cursor-pointer w-[40px] md:w-[60px] z-50"
                            alt=""
                        />{" "}
                        <div className="">
                            {" "}
                            {/* Ensure each item has a key and container */}
                            <div className="">
                                <Fade triggerOnce>
                                    <h1 className="md:w-1/2 w-full  ml-[-7px] h19">
                                        {item.title}
                                    </h1>
                                </Fade>{" "}
                                <Fade triggerOnce>
                                    <h5 className="mt-6 lg:mt-10 w-[75%] md:w-1/2 lg:w-[50%] xl:w-[50%] h22">
                                        {item.desc}
                                    </h5>
                                </Fade>
                       <Fade triggerOnce>
            <a 
                href={item.linkToWeb} 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block mt-6 lg:mt-10"
            >
                <button className="px-6 py-3 bg-blue-500 shadow-md border border-red-900 text-white rounded-full hover:bg-blue-700 transition-colors">
                    Go to Website
                </button>
            </a>
        </Fade>
                            </div>
                        </div>
                    </div>

                    <div
                        className=" w-full mt-24   h-full min-h-[100vh]  mx-auto "
                        id="secondpage"
                    >
                        {/* middle description ................................................................... */}
                        <div className="w-full flex md:mt-24 flex-col lg:flex-row">
                            <div className="w-full lg:w-1/3 flex  flex-col  gap-3 md:gap-14 ">
                                <Slide direction="left" triggerOnce>
                                    {" "}
                                    <p className="h21mt-[-3px]">{item.type1}</p>
                                </Slide>
                                <Slide direction="left" triggerOnce>
                                    {" "}
                                    <h5 className="mt-6 w-full md:w-1/2 h22">
                                        {item.productDesc}
                                    </h5>
                                    <a
                                        href={`https://${productDetails.linkToWeb}`}
                                    >
                                        <p className="mt-2 mb-10 h24 underline hover:text-white/70 duration-150 ease-in ">
                                            {productDetails.linkToWeb}
                                        </p>
                                    </a>
                                </Slide>
                            </div>
                            <div className="w-full lg:w-1/2 flex  flex-col  gap-3 md:gap-14 ">
                                <Slide direction="left" triggerOnce>
                                    {" "}
                                    <p className="">
                                        {item.type2.toUpperCase()}
                                    </p>
                                </Slide>{" "}
                                <Slide direction="left " triggerOnce>
                                    {" "}
                                    {item.productPara
                                        .split("\n")
                                        .map((line, index) => (
                                            <h5 className="h23" key={index}>
                                                {line}
                                            </h5>
                                        ))}
                                </Slide>
                            </div>
                        </div>{" "}
                        {/* middle description end  ................................................................... */}
                        {/* stats start   ................................................................... */}
                        {item?.stats?.map((y) => (
                            <div className="flex w-full md:mt-24  mt-[100px]  md:items-start ">
                                <div className="flex flex-col lg:flex-row w-full  ">
                                    <div className=" w-full lg:w-1/2 ">
                                        <p className="sm:text-[14px] leading-[42px] text-[12px] mb-10">
                                            SELECTED STATISTICS
                                        </p>
                                    </div>
                                    <div
                                        className="flex  flex-wrap  w-full"
                                        ref={statRef}
                                    >
                                        {statInView && (
                                            <div className=" w-full lg:w-1/2 flex  ">
                                                <div className=" w-full ">
                                                    <div className="flex h25 text-white">
                                                        <CountUp
                                                            suffix={
                                                                y.stat1Suffix
                                                            }
                                                            className="h25 text-white "
                                                            start={0}
                                                            end={y?.stat1}
                                                            duration={1}
                                                        />
                                                    </div>
                                                    <p className="h26">
                                                        {y.statName1}
                                                    </p>
                                                </div>
                                                <div className=" w-full">
                                                    <div className="flex h25 text-white">
                                                        <CountUp
                                                            suffix={
                                                                y.stat2Suffix
                                                            }
                                                            className="h25 text-white "
                                                            start={0}
                                                            end={y?.stat2}
                                                            duration={1}
                                                        />
                                                    </div>
                                                    <p className="h26">
                                                        {y.statName2}
                                                    </p>
                                                </div>
                                            </div>
                                        )}
                                        <div className=" w-1/3">
                                            <div className="flex h25 text-white">
                                                <CountUp
                                                    suffix={y.stat3Suffix}
                                                    className="h25 text-white "
                                                    start={0}
                                                    end={y?.stat3}
                                                    duration={1}
                                                />
                                            </div>
                                            <p className="h26">{y.statName3}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {/* productImages start   ................................................................... */}
                        <div className="flex w-full lg:pt-24 flex-wrap pt-10 z-[-10px]  relative ">
                            {item?.productImages?.map((x, index) => (
                                <div
                                    key={index}
                                    className={`${
                                        isLightcyclePage
                                            ? "lg:w-screen   z-[-10] static top-0"
                                            : "lg:w-1/3"
                                    } w-full z-[-10px]`}
                                >
                                    <img
                                        src={x.image}
                                        className={`z-[-10px] border w-full ${
                                            isLightcyclePage
                                                ? "border-none lg:w-[100%]   z-[-10] "
                                                : "border-white/60 lg:w-[95%]"
                                        }`}
                                        alt=""
                                    />
                                </div>
                            ))}
                        </div>
                        <h3 className="mb-10 mt-[100px] lg:mt-[150px] sm:text-[24px] leading-[42px] text-[14px] h8 ">
                            OTHER PRODUCTS
                        </h3>
                        <div className="flex flex-row flex-wrap  ">
                            {data.art.map((item) => (
                                <div className="lg:w-1/3 w-full  z-50 ">
                                    <OtherProductsCard item={item} />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ))}
            <div
                data-depth="0.1"
                className={`absolute inset-0  z-[-10]`}
                // ref={sceneRef}
            >
                <img
                    // ref={imgRef}
                    src={productDetails.imagefull}
                    alt=""
                    className={` object-cover h-screen  object-center   w-full `}
                />
            </div>{" "}
        </div>
    );
}

export default SingleProject;
